import type { ComponentChildren } from 'preact';

type ChatBubbleSide = 'dealer' | 'customer';

interface ChatBubbleProps {
  children: ComponentChildren;
  side?: ChatBubbleSide;
}

export function ChatBubble({ children, side = 'dealer' }: ChatBubbleProps) {
  return (
    <div className="sm-type-body sm-animate-in sm-chat-tail sm-chat-bubble" data-side={side}>
      {children}
    </div>
  );
}
